<template>
  <main id="products-list" class="site-main">
    <div class="grid-container">
      <div class="page-header grid-x grid-padding-x align-middle">
        <div class="cell auto">
          <h1 class="page-header__title">Products</h1>

          <div class="text-right">
            <span class="icon-action" @click="exportProducts">
              <i class="far fa-arrow-to-bottom"></i> <span>Export</span>
            </span>
          </div>
        </div>
      </div>

      <div class="panel no-padding">
        <searchBar placeholder="Search products" @sort="sort"
                   :value="searchValue" @search="search"  :dateFilter="true"
                   @dateFilter="dateFilter"></searchBar>

        <div :class="['loading-area', loading ? 'loading' : '']">
          <div :class="['loading-area__content', loading ? 'loading' : '']">
            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total" @paginate="paginate"></pagination>

            <div style="overflow: scroll;">
              <tableList :header="tableHeader" :data="tableData"
                         :loading="loading" @sort="orderBy" @callback="callback"
                         style="min-width: 1600px;"
                         @post="go"></tableList>
            </div>

            <pagination :prev="prev" :next="next" :start="start" :end="end"
                        :total="total" @paginate="paginate"></pagination>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import { PREFIX } from '@/localSettings'
import moment from 'moment'

export default {
  mixins: [client, paginationUtils],
  data: function () {
    return {
      action: '/products/?expand=variants&vendor=' + this.$store.state.vendors[this.$store.state.currentVendor].id,
      sort: 'title',
      tableHeader: {
        currentSort: 'title',
        data: [
          {
            label: 'Product',
            class: 'full',
            sort: 'title'
          },
          {
            label: 'SKU',
            class: 'large'
          },
          {
            label: 'Barcode',
            class: 'medium'
          },
          {
            label: 'Price',
            class: 'large'
          },
          {
            label: 'Item Cost'
          },
          {
            label: 'Inventory',
            class: 'xlarge'
          },
          {
            label: 'Paid',
            class: 'small'
          },
          {
            label: 'Sold',
            class: 'small'
          },
          {
            label: 'Available',
            class: 'large'
          },
          {
            label: 'Commission',
            class: 'medium'
          },
          {
            label: 'Earning Potential',
            class: 'medium'
          },
          {
            label: 'Created',
            class: 'large',
            sort: 'created_at'
          },
          {
            label: 'View',
            class: 'medium'
          }
        ]
      },
      tableData: [],
      blockedDomains: [
        'qualityfood.myshopify.com',
        'physicians-longevity.myshopify.com',
        'the-harmonic-au.myshopify.com',
        'kina-11.myshopify.com',
        'kingsroy-gallery.myshopify.com',
        'curated-cubs.myshopify.com',
        'dantes-luxury-lifestyle.myshopify.com',
        'stylecolab-preloved.myshopify.com',
        'lisco-ny.myshopify.com',
        'starlitdreamer.myshopify.com',
        'renee-taylor-gallery.myshopify.com',
        '905abc-15.myshopify.com'
      ]
    }
  },
  methods: {
    exportProducts () {
      let exportAction = '/products/?expand=variants&vendor=' + this.$store.state.vendors[this.$store.state.currentVendor].id
      if (this.$store.state.portalSettings.myshopify_domain === 'deathwish-inc.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'fd7208-a5.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'the-harmonic-au.myshopify.com') {
        exportAction = '/products/variants/?vendor=' + this.$store.state.vendors[this.$store.state.currentVendor].id
      }

      this.request('get', exportAction, {
        format: 'csv'
      }).then((response) => {
        let downloadLink = document.createElement('a')

        downloadLink.href = response
        downloadLink.target = '_blank'

        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)

        this.loading = false
      })
    },
    dateFilter (startDate, endDate) {
      this.params = {}
      if (startDate.length > 0) {
        this.params['start_date'] = startDate
      } else {
        delete this.params['start_date']
      }

      if (endDate.length > 0) {
        this.params['end_date'] = endDate
      } else {
        delete this.params['end_date']
      }

      if (this.params['start_date'] || this.params['end_date']) {
        this.action = '/products/sold/?expand=variants&vendor=' + this.$store.state.vendors[this.$store.state.currentVendor].id
      } else {
        this.action = '/products/?expand=variants&vendor=' + this.$store.state.vendors[this.$store.state.currentVendor].id
      }

      this.getData()
    },
    go: function (id) {
      this.$router.push(PREFIX + '/products/' + id)
    },
    viewProduct (handle) {
      let link = document.createElement('a')
      link.href = 'https://' + this.$store.state.portalSettings.domain + '/products/' + handle + '/'
      link.target = '_blank'

      link.click()
    },
    buildTable () {
      for (let i = 0; i < this.data.length; i++) {
        if (this.$store.state.portalSettings.myshopify_domain === 'lisco-ny.myshopify.com') {
          this.data[i].image = this.data[i].product.image
          this.data[i].title = this.data[i].product.title + '<br>' + this.data[i].title
          this.data[i].product_type = this.data[i].product.product_type
        }

        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (!this.isEmpty(this.data[i].image)) {
          let ext = this.data[i].image.split('.').pop()

          this.data[i].image = this.data[i].image.replace('.' + ext, '_100x100.' + ext)

          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + this.data[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        primary += '</div></div><div class="cell auto">' + this.data[i].title + '</div></div>'

        let variantCount = 0
        let inventoryCount = 0
        let inventoryNotTracked = 0
        let sold = 0
        let paid = 0

        if (this.$store.state.portalSettings.myshopify_domain !== 'lisco-ny.myshopify.com') {
          for (let j = 0; j < this.data[i]['variants'].length; j++) {
            variantCount++
            inventoryCount += this.data[i]['variants'][j]['inventory_quantity']
            sold += this.data[i]['variants'][j]['sold']
            paid += this.data[i]['variants'][j]['paid']

            if (!this.data[i]['variants'][j]['inventory_management']) {
              inventoryNotTracked++
            }
          }
        } else {
          inventoryCount = this.data[i].inventory_quantity
          variantCount = 1
        }

        let inventory = inventoryCount + ' in stock'

        if (variantCount > 1) {
          inventory = inventory + ' for ' + variantCount + ' variants'
        }

        // if (inventoryNotTracked === variantCount) {
        //   inventory = '<span class="text-medium-gray-color">inventory not tracked</span>'
        // }

        let commissionCol = {}

        if (this.$store.state.metas.vendor_field_commissions.meta_value) {
          commissionCol = {
            value: this.formatMoney(this.data[i].commission),
            class: 'medium',
            span: 'focus-text'
          }
        }

        let inventoryCol = {
          value: inventory,
          class: 'xlarge'
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'leivitorloveit.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'mostlymusic.myshopify.com') {
          inventoryCol = {}
        }

        let priceCol = {}

        if (this.$store.state.metas.vendor_field_sell_price.meta_value !== false) {
          let lowestPrice = 9999999999

          if (this.data[i].variants) {
            for (let j = 0; j < this.data[i].variants.length; j++) {
              if (this.data[i].variants[j].price < lowestPrice) {
                lowestPrice = this.data[i].variants[j].price
              }
            }

            let price = this.formatMoney(lowestPrice)

            if (this.data[i].variants.length > 1) {
              price = 'starting at %s' % price
            }

            priceCol = {
              value: price,
              class: 'large',
              span: 'fill'
            }
          }
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'curated-cubs.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'the-thrifting-den.myshopify.com') {
          commissionCol = {
            value: this.formatMoney(this.data[i].variants[0].cost_per_item),
            class: 'medium',
            span: 'focus-text'
          }
        }

        let availableCol = {}

        if (this.$store.state.portalSettings.myshopify_domain === 'stylecolab-preloved.myshopify.com') {
          // skuCol = {}
          availableCol = {
            value: 'Start: ' + this.data[i].start_date + '<br>End: ' + this.data[i].end_date,
            class: 'large'
          }
        }

        let paidCol = {}

        if (this.$store.state.portalSettings.myshopify_domain === 'dantes-luxury-lifestyle.myshopify.com') {
          paidCol = {
            value: paid,
            class: 'small'
          }
        }

        let barcodeCol = {}
        if (this.$store.state.portalSettings.myshopify_domain !== 'renee-taylor-gallery.myshopify.com') {
          barcodeCol = {
            value: this.data[i].variants[0].barcode,
            class: 'medium'
          }
        }

        let skuCol = {}

        if (this.$store.state.portalSettings.myshopify_domain === 'kina-11.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com') {
          let sku = ''
          if (this.data[i].variants) {
            if (this.data[i].variants.length > 1) {
              sku = 'multiple'
            } else {
              sku = this.data[i].variants[0].sku
            }
          }

          skuCol = {
            value: sku,
            class: 'large'
          }
          barcodeCol = {}
        }

        let costCol = {}

        if (this.$store.state.portalSettings.myshopify_domain === 'curated-cubs.myshopify.com') {
          let costPerItem = 0.0

          if (this.data[i].variants[0].cost_per_item) {
            costPerItem = this.data[i].variants[0].cost_per_item
          }
          costCol = {
            value: this.formatMoney(costPerItem),
            class: 'medium'
          }
        }

        let viewCol = {
          value: '<button class="button">View</button>',
          class: 'medium',
          callback: 'viewProduct',
          callbackArgs: [this.data[i].handle]
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'starlitdreamer.myshopify.com') {
          viewCol = {}
        }

        let statusCol = {}

        let soldcol = {
          value: sold,
          class: 'small'
        }

        if (this.$store.state.portalSettings.myshopify_domain === 'qualityfood.myshopify.com') {
          statusCol = {
            value: this.data[i].status,
            class: 'medium'
          }
          paidCol = {}
          commissionCol = {}
          soldcol = {}
        }

        let earningCol = {
          value: this.data[i].get_earning_potential,
          class: 'medium'
        }

        if (this.$store.state.portalSettings.myshopify_domain !== '905abc-15.myshopify.com') {
          earningCol = {}
        }

        if (!this.blockedDomains.includes(this.$store.state.portalSettings.myshopify_domain)) {
          if (!this.$store.state.metas.vendor_field_commissions.meta_value === false) {
            commissionCol = {}
          }

          if (this.$store.state.metas.vendor_field_sell_price.meta_value === false) {
            priceCol = {}
          }

          this.tableData.push({
            post: this.data[i].id,
            data: [
              {
                value: primary,
                class: 'full'
              },
              barcodeCol,
              priceCol,
              inventoryCol,
              paidCol,
              commissionCol,
              statusCol,
              {
                value: moment(this.data[i].created_at).format('MMM D, YYYY'),
                class: 'large'
              },
              viewCol
            ]
          })
        } else {
          this.tableData.push({
            post: this.data[i].id,
            data: [
              {
                value: primary,
                class: 'full'
              },
              skuCol,
              barcodeCol,
              // {
              //   value: this.data[i].product_type,
              //   class: 'large'
              // },
              priceCol,
              costCol,
              inventoryCol,
              soldcol,
              paidCol,
              availableCol,
              commissionCol,
              earningCol,
              statusCol,
              {
                value: moment(this.data[i].created_at).format('MMM D, YYYY'),
                class: 'large'
              },
              viewCol
            ]
          })
        }
      }
    }
  },
  created () {
    if (this.$store.state.portalSettings.myshopify_domain !== '905abc-15.myshopify.com') {
      this.tableHeader.data[10] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'renee-taylor-gallery.myshopify.com') {
      this.tableHeader.data[2] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'starlitdreamer.myshopify.com') {
      this.tableHeader.data[11] = {}
    }

    if (!this.$store.state.metas.vendor_field_commissions.meta_value) {
      this.tableHeader.data[8] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'lisco-ny.myshopify.com') {
      this.action = '/products/variants/?vendor=' + this.$store.state.vendors[this.$store.state.currentVendor].id
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'stylecolab-preloved.myshopify.com') {
      // this.tableHeader.data[1] = {}
    } else {
      this.tableHeader.data[7] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'dantes-luxury-lifestyle.myshopify.com') {
      this.tableHeader.data[4] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain !== 'curated-cubs.myshopify.com') {
      this.tableHeader.data[3] = {}
    }

    if (this.$store.state.metas.vendor_field_sell_price.meta_value === false) {
      this.tableHeader.data[2] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com') {
      if (!this.$store.state.metas.vendor_field_commissions.meta_value) {
        for (let i = 0; i < this.tableHeader.data.length; i++) {
          if (this.tableHeader.data[i].label === 'Commission') {
            this.tableHeader.data[i] = {}
          }
        }
      }
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'kina-11.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'kingsroy-gallery.myshopify.com') {
      for (let i = 0; i < this.tableHeader.data.length; i++) {
        if (this.tableHeader.data[i].label === 'Available') {
          this.tableHeader.data[i] = {}
        }
      }
    } else {
      this.tableHeader.data[1] = {}
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'qualityfood.myshopify.com') {
      this.tableHeader.data = [
        {
          label: 'Product',
          class: 'full',
          sort: 'title'
        },
        {
          label: 'Barcode',
          class: 'medium'
        },
        {
          label: 'Price',
          class: 'large'
        },
        {
          label: 'Inventory',
          class: 'xlarge'
        },
        {
          label: 'Status',
          class: 'medium'
        },
        {
          label: 'Created',
          class: 'large',
          sort: 'created_at'
        },
        {
          label: 'View',
          class: 'medium'
        }
      ]
    }

    if (this.$store.state.portalSettings.myshopify_domain === 'physicians-longevity.myshopify.com' || this.$store.state.portalSettings.myshopify_domain === 'the-harmonic-au.myshopify.com') {
      this.action = '/products/?expand=variants'
    }

    if (!this.blockedDomains.includes(this.$store.state.portalSettings.myshopify_domain)) {
      this.tableHeader.data = [
        {
          label: 'Product',
          class: 'full',
          sort: 'title'
        },
        {
          label: 'Barcode',
          class: 'medium'
        },
        {
          label: 'Price',
          class: 'large'
        },
        {
          label: 'Inventory',
          class: 'xlarge'
        },
        {
          label: 'Paid',
          class: 'small'
        },
        {
          label: 'Commission',
          class: 'medium'
        },
        {
          label: 'Created',
          class: 'large',
          sort: 'created_at'
        },
        {
          label: 'View',
          class: 'medium'
        }
      ]
    }

    if (!this.$store.state.metas.vendor_field_commissions.meta_value === false) {
      this.tableHeader.data[5] = {}
    }

    if (this.$store.state.metas.vendor_field_sell_price.meta_value === false) {
      this.tableHeader.data[2] = {}
    }

    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/mixins';
@import '../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/pages/vendorPortal/products.vue